import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { ExploreProducts } from '../../../components';

export const EmptySubscriptionGroup = () => (
  <Box
    id="empty-subscription-group"
    key="empty-subscription-group"
    border={theme => `1px solid ${theme.refV2.cat.gray[200]}`}
    display="flex"
    flexDirection="column"
    marginTop={2}
    padding={4}
    width="100%"
    sx={theme => ({
      [theme.breakpoints.down('tablet')]: {
        width: '100%',
      },
    })}
  >
    <Box
      id="empty-subscription-group-desc"
      key="empty-subscription-group-desc"
      display="flex"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      <Typography variant="body1" fontWeight={500} fontSize={16}>
        <FormattedMessage id="page.subscription.empty.subscription.desc" />
      </Typography>
    </Box>
    <Box
      id="empty-subscription-group-explore-plan"
      key="empty-subscription-group-explore-plan"
      display="flex"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      width="100%"
      paddingTop={2}
    >
      <ExploreProducts />
    </Box>
  </Box>
);
